/*  MUI  */
import { Box, Divider, Typography } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

export const ContractSectionTitle = ({ title, subtitle }) => (
    <Box
        marginTop="64px"
        data-testid="contractSectionTitle"
        sx={{ backgroundColor: 'background.contractSectionTitle' }}
    >
        <Typography
            data-testid="contractSectionTitleTitle"
            fontWeight={600}
            variant="h5"
        >
            {title}
        </Typography>
        {subtitle && (
            <Typography
                data-testid="contractSectionTitleSubtitle"
                fontSize={FontSizes[2]}
                fontWeight={600}
                mt="8px"
                variant="h6"
            >
                {subtitle}
            </Typography>
        )}
        <Box py="16px">
            <Divider
                data-testid="contractSectionTitleDivider"
                sx={{
                    borderColor: 'border.divider',
                    borderRadius: '20px',
                    borderWidth: '4px',
                    opacity: 1
                }}
            />
        </Box>
    </Box>
);
